// JavaScript Document
//components/signs/type/Form.js
import React from 'react';
//import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
//import AppBar from '@material-ui/core/AppBar';

//import {flexbox} from '@material-ui/system';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
//import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
//import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';

import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import SaveIcon from '@material-ui/icons/Save';
//import DeleteIcon from '@material-ui/icons/Delete';
import ImagePicker from '../forms/ImagePicker';
import DeleteButton from '../../core/DeleteButton';
//import TextArea from '@material-ui/core/TextareaAutosize';
//import Display from '../../display/Display';
//import Paper from '@material-ui/core/Paper';

const useStyles = makeStyles((theme) => ({
	formCard : {
		marginBottom: theme.spacing(3),
		display: "flex",
		flexDirection:"column",
		alignItems:"stretch",
		justifyContent:"center",
		flexWrap:"wrap"
	},
	advancedContent : {
		display: "flex",
		flexGrow: 1,
		alignItems: "center",
		justifyContent: "space-around",
		flexWrap: "wrap"
	},
	detailsVerticalCenter: {
		display: "flex",
		alignItems:"center",
		justifyContent:"space-around",
		flexGrow: 1,
		flexDirection: "column",
		flexWrap: "wrap",
	},
	detailsHorizontal : {
		display: "flex",
		flexGrow:1,
		alignItems:"stretch",
		justifyContent:"space-between",
		flexWrap:"wrap",
		flexDirection:"row",
		width: "100%"
	},
	input75 : {
		minWidth : 100,
		maxWidth: 300
	},
	input25 : {
		minWidth: 10,
		maxWidth: 30
	},
	sizeInput : {
		minWidth: 50,
		maxWidth: 200,
	},
	timingInput : {
		margin: theme.spacing(1),
		width: 90
	},
  maxDisplayGrid: {
	  minHeight: 300
  }
}));

export default function TypeForm(props) {
  	const classes = useStyles();
	//inherited variables
  	const {handleSend, item, pics, onChange, categories, signClasses} = props;
	//locally stored/copied variables
	const [isNew, setIsNew] = React.useState(false);
	const [changed, setChanged] = React.useState(false);
	const [saveLabel, setSaveLabel] = React.useState('Save');

	const [details, setDetails] = React.useState({
		id: '',
		name: '',
		description: '',
		pic: '',
		type: 'sign_type',
		opt_width: 0,
		opt_height: 0,
		opt_digits: 0,
		opt_class: 0,
		opt_cat: 0,
	});
	const limits = {
		opt_width:99,
		opt_height:99,
		opt_digits:3
	};
	//local state varialbes user will change
	//Local constant for maximum value
	
	//Refresh UI on props change
	React.useEffect(() => {
		if(!item.id){
			setIsNew(true);
		} else {
			setIsNew(false);
		}
		if(
			item.id 
			&& item.id !== details.id
		) {
			//console.log('config has changed');
			setDetails(item);
			
		}
	}, [details.id, item]);
	
	//handle change any value
	const handleChangeValue = (e) => {
		let name = e.target.name;
		let value = e.target.value
		let newDetails = Object.assign({}, details);
		
		//if numeric
		if([
			'opt_height', 
			'opt_width',
			'opt_digits'
		   ].indexOf(name) !== -1){
			value = parseInt(value);
			//clean the value
			if(isNaN(value) || value < 0){
				value = 0;
			} else if(value > limits[name]){
				value = limits[name];
			}
		}
		
		newDetails[name] = value;
		setDetails(newDetails);
		setChanged(true);
	}
	
	//Handle save buttonclick
	const handleSave = (e) => {
		setSaveLabel('Saving');
		console.log("Save button clicked!");
		handleSend({
			vso: 'option',
			option: details,
			subaction: 'save'
		}, (data) => {
			console.log(data);
			setChanged(false);
			setSaveLabel('Save');
			//setConfig(data.config);
			setDetails(data.option);
			//update parent if onChange is supplied
			if(onChange){
				onChange(data.option, isNew);
			}
			setIsNew(false);
			
		});
	}
	//Handle update parent if onChange is provided
	/*
	const handleUpdateParent = (newTiming, newDim, newAlternate) => {
		if(onChange){
			console.log('Updating parent');
			onChange([newTiming.wigOn, newTiming.wigOff, newTiming.wagOn, newTiming.wagOff], newDim, newAlternate);
		}
	}
	*/
	//Final delete clicked
	const handleDelete = () => {
		setIsNew(true);
		handleSend({
			vso: 'option',
			option: details,
			subaction: 'delete'
		}, (data) => {
			setChanged(false);
			setIsNew(false);
			if(onChange){
				onChange(false);
			}
		});
	}
	

	
	//render card actions (save & Delete)
	const cardActions = () => {
		return (
			<ButtonGroup>
				{saveButton()}
				<DeleteButton onClick={handleDelete} visible={!isNew} />
			</ButtonGroup>
		)
	}
	

	const saveButton = () => {
		if(changed){
			return (
				<Button 
					variant="contained" 
					color="primary" 
					onClick={handleSave} 
					endIcon={<SaveIcon />}
					disabled={saveLabel==='Saving' ? true : false}
				>
					{saveLabel}
				</Button>
			);
		}
		return '';
	}
	
  	//standard size: 
	//1 panel = 6 x 9 x 2 rows = 30 x 18

  	return (
    	<Card className={classes.formCard}>
			<CardHeader title={isNew ? 'New Sign Type' : details.name} action={cardActions()}/>
	  		<CardContent>
				<Grid container spacing={3}>
					<Grid item xs={12} sm={4}>
						<TextField
							id="type_name"
							name="name"
							label="Name"
							required
							value={details.name}
							type="text"
							inputProps = {{
									  maxlength:"25"
									 }}
							onChange={handleChangeValue}
							fullWidth
						/>
						<TextField
							id="opt_cat"
							name="opt_cat"
							label="Category"
							value={details.opt_cat}
							onChange={handleChangeValue}
							fullWidth
							select
						>
							{categories.map((row) => (
							<MenuItem value={row.id} key={row.id}>{row.name}</MenuItem>
							))}
						</TextField>
						<TextField
							id="opt_class"
							name="opt_class"
							label="Class"
							value={details.opt_class}
							onChange={handleChangeValue}
							fullWidth
							select
						>
							{signClasses.map((row) => (
							<MenuItem value={row.id} key={row.id}>{row.name}</MenuItem>
							))}
						</TextField>
						<TextField
							id="class_description"
							name="description"
							label="Description"
							multiline
							maxRows={4}
							value={details.description}
							onChange={handleChangeValue}
							fullWidth
					/>
				</Grid>
				<Grid item xs={12} sm={4}>
					<TextField
							id="type_part"
							name="part"
							label="Part Number"
							value={details.part}
							onChange={handleChangeValue}
							inputProps = {{
									  maxlength:"25"
									 }}
							fullWidth
						/>
					<Grid container spacing={3}>
						<Grid item xs={12} sm={4}>
							<TextField
								id="panel_width"
								name="opt_width"
								label="Width"
								type="number"
								value={details.opt_width.toString()}
								onChange={handleChangeValue}
								inputProps={{min:'0', max:limits.opt_width, style:{textAlign:'center'}}}
								fullWidth
							/>
						</Grid>
						<Grid item xs={12} sm={4}>
							<TextField
								id="panel_height"
								name="opt_height"
								label="Height"
								type="number"
								value={details.opt_height.toString()}
								onChange={handleChangeValue}
								inputProps={{min:'0', max:limits.opt_height, style:{textAlign:'center'}}}
								fullWidth
							/>
						</Grid>
						<Grid item xs={12} sm={4}>
							<TextField
								id="digit_num"
								name="opt_digits"
								label="Digits"
								type="number"
								value={details.opt_digits.toString()}
								onChange={handleChangeValue}
								inputProps={{min:'0', max:limits.opt_digits, style:{textAlign:'center'}}}
								fullWidth
							/>
						</Grid>
					</Grid>
					<Grid container spacing={3}>
						<Grid item xs={12} sm={8}>
							<TextField
								id="type_configvar"
								name="cfg_reference"
								label="Configuration variable"
								value={details.cfg_reference}
								fullWidth
								type="text"
								inputProps = {{
									  	maxlength:"25"
									 }}
								onChange={handleChangeValue}
							/>
						</Grid>
						<Grid item xs={12} sm={4}>
							<TextField
								id="configvar_value"
								name="value"
								label="Value"
								value={details.value}
								type="text"
								fullWidth
								inputProps = {{
									  	maxlength:"1"
									 }}
								onChange={handleChangeValue}
							/>
						</Grid>
					</Grid>
				</Grid>
				<Grid item xs={12} sm={4}>
					<ImagePicker
						id="class_pic"
						label="Image"
						name="pic"
						value={details.pic}
						items={pics}
						onChange={handleChangeValue}
						select
					/>
				</Grid>
			</Grid>
	  		</CardContent>
	  	</Card>
  );
}
